module.exports = __webpack_public_path__ + "static/media/SI-Rating-w.2aeeb46a.png";